import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const KRIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="KR" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#3D58DB"
          fillRule="evenodd"
          d="M8 9.11c1.601 0 2.9-1.379 2.9-3.08 0-1.7-1.299-3.079-2.9-3.079S5.1 4.33 5.1 6.031C5.1 7.73 6.4 9.11 8 9.11Z"
          clipRule="evenodd"
        />
        <Mask
          id="c"
          width={6}
          height={8}
          x={5}
          y={2}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <Path
            fill="#fff"
            fillRule="evenodd"
            d="M8 9.11c1.601 0 2.9-1.379 2.9-3.08 0-1.7-1.299-3.079-2.9-3.079S5.1 4.33 5.1 6.031C5.1 7.73 6.4 9.11 8 9.11Z"
            clipRule="evenodd"
          />
        </Mask>
        <G mask="url(#c)">
          <Path
            fill="#E31D1C"
            fillRule="evenodd"
            d="M11.001 6.266s-.163-1.452-1.368-1.53c-1.205-.08-1.53 1.064-1.6 1.367-.07.303-.246 1.111-1.515 1.111S5.135 5.16 5.135 5.16V2.736H11v3.53Z"
            clipRule="evenodd"
          />
        </G>
        <Path
          fill="#272727"
          d="m5.613 2.787-2.05 2.459-.457-.414 2.05-2.458.457.413Zm-.751-.678L2.818 4.55l-.458-.413 2.045-2.44.457.413Zm-.755-.669-2.12 2.476-.457-.414 2.12-2.476.457.414ZM12.125 4.32l.794.931.457-.412-.793-.932-.458.412Zm-.627-2.404 2.209 2.69.458-.413-2.21-2.69-.457.413Zm2.137 1.063.793.93.458-.412-.794-.932-.457.414Zm-2.92-.373.792.932.459-.412-.794-.932-.458.412Zm1.51-1.341.793.931.457-.412-.793-.931-.458.412ZM13.205 10.114l-.8.935-.462-.413.8-.936.462.414Zm-.76-.71-.836.997-.461-.414.835-.998.461.414Zm-.763-.637-.8.935-.462-.414.8-.935.462.414Zm2.802-.337-.8.935-.461-.413.8-.936.461.414Zm-.669-.691-.835.999-.461-.414.835-.999.461.414Zm-.788-.617-.8.934-.461-.414.8-.934.461.414ZM1.697 8.758 3.75 11.13l.458-.413-2.054-2.371-.457.412Zm1.983.734.862.947.458-.413-.862-.947-.458.413Zm-.477-2.047 2.042 2.34.458-.413-2.042-2.34-.458.413Zm-.723.631.749.877.457-.413-.748-.877-.458.413Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
